// ─────────────────────────────────────────────────────────────────────────────
// Countries — for the foreign onboarding form (PM-0061).
//
// The SAME rows as the sign-in page's catalogue
// (sso/parsina.keycloakify/src/login/lib/countries.ts), reduced to what a
// country PICKER needs: the ISO code that is stored, the calling code that
// preselects the country of the number the doctor signed in with, and the name
// in each language the panel ships. Add a country there first, then here.
//
// `iso2` is what goes on the wire and into the practitioner record; a name is
// only ever display. The rows are data, so they live in countries.json.
// ─────────────────────────────────────────────────────────────────────────────

import rows from './countries.json';

export const COUNTRIES = rows;

/** The country's name in `locale`, falling back to English — never to a code. */
export const countryName = (country, locale) =>
  country?.[String(locale || '').split('-')[0]] || country?.en || '';

const toLatinDigits = (value) =>
  String(value ?? '').replace(/[۰-۹٠-٩]/g, (ch) => {
    const code = ch.charCodeAt(0);
    return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
  });

/**
 * The country an international number belongs to, or null.
 *
 * Calling codes are prefix-free, so the first row whose code the number starts
 * with is the only one that can match. Where several countries SHARE a code
 * (+1, +7) the first row in the list answers — good enough for a default the
 * doctor can change, and the reason this is never used to decide anything.
 */
export function countryForPhone(phone) {
  const compact = toLatinDigits(phone).replace(/[\s\-().]/g, '');
  const match = /^(?:\+|00)(\d{6,15})$/.exec(compact);
  if (!match) return null;
  return COUNTRIES.find((c) => match[1].startsWith(c.dial)) || null;
}
